
export const UPGRADE_MANAGEMENT_SERVICE = 'lifesize.softwareUpdate';

export enum UPGRADE_MANAGEMENT_CHANNEL {
  GENERAL_AVAILABILITY = 'GeneralAvailability',
  BETA = 'Beta',
  ALPHA = 'Alpha'
}
